import * as React from "react";

import { IconEdit } from "../icons/IconEdit";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";

interface IconButtonEditProps extends MprcIconButtonProps {
    iconSize?: SizeProp;
}

export const IconButtonEdit: React.FC<IconButtonEditProps> = ({ title, iconSize, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonEdit.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconEdit fixedWidth size={iconSize} />
        </MprcIconButton>
    );
};
